// extracted by mini-css-extract-plugin
export default {"avatar":"QuestionsList_avatar__Lr69L","search":"QuestionsList_search__i1b3f"};